export default "__VITE_ASSET__DG7M7PF3__"